import Vue from 'vue';
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-2';
export default Vue.extend({
    name: 'Quote',
    components: {
        NodeViewWrapper
    },
    props: nodeViewProps
});
